import { jsx as _jsx } from "react/jsx-runtime";
import { TourTrackingProvider } from 'ui-shepherd-tracker/contexts/TourTrackingProvider';
import { TourFeatures } from '../constants/tourFeatures';
export const OnboardingTourTrackingProvider = ({
  children,
  tourId
}) => {
  const tourFeature = TourFeatures[tourId];

  if (!tourFeature || !tourFeature.shepherdTracker) {
    return children;
  }

  return /*#__PURE__*/_jsx(TourTrackingProvider, {
    appName: "onboarding-tours",
    children: children
  });
};